import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["method", "credentials", "invitationNote", "credentialsNote"]

  connect() {
    this.change()
  }

  change() {
    const credentials = this.methodTargets.some(input => input.checked && input.value === "credentials")
    this.credentialsTarget.hidden = !credentials
    this.credentialsTarget.disabled = !credentials
    this.invitationNoteTarget.hidden = credentials
    this.credentialsNoteTarget.hidden = !credentials

    const label = this.element.closest(".dialog")?.querySelector("[data-client-user-access-submit-label]")
    if (label) label.textContent = credentials ? "Create login" : "Send invitation"
  }
}
